// @flow
import { createAction } from 'redux-actions';
import {
    SWITCH_COORDINATE_SYSTEM,
} from './constants';

// eslint-disable-next-line
export const switchCoordinateSystem = createAction(SWITCH_COORDINATE_SYSTEM);
